import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function authorizeChildToGoOutAlone(id: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.authorizeChildToGoOutAlone.url, { id }))
    .post<unknown>()
}

export function unauthorizeChildToGoOutAlone(id: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.unauthorizeChildToGoOutAlone.url, { id }))
    .post<unknown>()
}

export const resendAuthorizationToGoOutAlone = (id: number) => {
  return restApiClient
    .url(constructApiUrl(API.enrollments.resendAuthorizationToGoOutAlone.url, { id }))
    .post<unknown>()
}
